var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"1200px","min-height":"700px"},attrs:{"id":"watts-vars-pf-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }